
import { Component, Prop, Vue } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';

@Component({ components: { Popup } })
export default class MessagePopup extends Vue {
  @Prop() private message!: string;
  @Prop() private title!: string;
  @Prop() private isVisible!: boolean;
  private hidePopup(): void {
    this.$emit('close');
  }
}
